import { Button } from '@progress/kendo-react-buttons';
import React, { ReactNode, useEffect, useState } from 'react';
import './MaxExperience.scss';
import { title } from 'process';
import { User } from '../../types/user';
import { TinyObj } from '../../types/TinyObj';
import userGroupsService from '../../services/usergroups.service';
import welcomejourneyService from '../../services/welcomejourney.service';
import { sortUsersData } from '../../utils/userUtil';
import { SupervisorWelcomeData } from '../../types/welcomejourney/SupervisorWelcomeData';
import useTranslation from '../../hooks/useTranslation';
import useAuth from '../../hooks/useAuth';
import usersService from '../../services/users.service';
import { useNavigate } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';
import { Customer } from '../../types/customer';
import customerService from '../../services/customer.service';
import deviceService from '../../services/device.service';
import { DeviceAllocation } from '../../types/device/deviceAllocation';
import { AccessPermissionEnum } from '../../enums';
import { Loader } from '@progress/kendo-react-indicators';

type MaxExperienceProps = {
};

type HeaderEXpProps = {
  title: string | string[];
  description: string | string[];
}

interface IUserRecordingNetworkGroup {
  groupDetail: TinyObj;
  users: User[];
};


const HeaderExp: React.FC<HeaderEXpProps>=({title, description})=>{
  return (
    <div className='exp-head'>
      <h3 className='text-primary mb-1'>
        {title}
      </h3>
      <span className=''>
        {description}
      </span>
    </div>
  )
}

type ExpListProps = {
  icon:string[];
  link:string;
  linkTitle: string | string[];
  description: string | string[];
  permissions: number[];
}

const ExpList: React.FC<ExpListProps>=({icon, link, linkTitle, description})=>{
  return (
    <div className='max-exp-list d-flex align-items-base'>
      <div className='icon-container mr-3'>
          <div className="icon-set text-primary">
            {icon.map((items)=>
                <i key={items} className={`bi ${items}`}></i>
            )}
          </div>
      </div>
      <div className="content-set">
        <a href={link} target="_blank">
          <div className="d-flex align-items-center">
            <h6 className=''>
            {linkTitle}
            </h6>
        
            <h6 className='ml-2 bi bi-arrow-right-circle-fill'>
            </h6>
          </div>
        </a>
        <p className=''>
          {description}
        </p>
      </div>
    </div>
  )
}

type MemberRowTableProps = {
    icon:string | string[];
    title:string;
    email: string;
    license: string | string[];
    policy:string | string[];
    isTeams: boolean;
}

const MemberRowTable: React.FC<MemberRowTableProps> = ({icon, title, email, license, policy, isTeams}) =>{

  return (
    <tr>
      <td>
        <div className="tblUsr w-100">
          <div className="topUsrAreaPic">
              <div className="topUsrAreaPic-i">
                <div
                  className="contact-list-icon cursor-pointer bg-primary" title={title}
                >
                  <div className="contact-list-icon-txt">{icon}</div>
                </div>
              </div>
              <div className="topUsrAreaPic-tx">
                <span className='cursor-default text-decoration-none float-left w-100 line-height-1 mx-td-spn viewFullWordHover'>
                {title}
                </span>
                <span className='text-muted fs-11 line-height-1 mx-td-spn viewFullWordHover cursor-default'>
                {email}
                </span>
              </div>
          </div>
        </div>
      </td>
      <td>
        <span className='fs-13'>{license}</span>
      </td>
      {isTeams && (<td>
        <span className='fs-13'>{policy}</span>
      </td>)}
    </tr>
  )
}




const MaxExperience: React.FC<MaxExperienceProps> = () => {
  const [dataloading, setDataloading] = useState<boolean>();
  var _tempMyPeople: User[] = [];
  const transLicense = useTranslation("LicensePackage");  
  const [dialogData, setDialogData] = useState<SupervisorWelcomeData[]>();
  const auth = useAuth();
  const [isTeams, setIsTeams] = useState<boolean>(false);
  const trans = useTranslation("MaxExperience");
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const language = searchParams.get("language");
  const [isAdmin, setIsAdmin] = useState<boolean>(false);

  const dataList: ExpListProps[] = [
    { 
      icon:['bi-people'],
      link: '/settings/user-control',
      linkTitle:  trans.fetchLabelKeyTranslation('TitlePermissionGroups', 'Create Permission Groups'),
      description: trans.fetchLabelKeyTranslation('DescPermissionGroups','Create custom groups with different access permissions'),
      permissions: [AccessPermissionEnum.ManageUsersAndGroups, AccessPermissionEnum.ManageSecurityControl]
    },
    { 
      icon:['bi-snow'],
      link: '/settings/topics',
      linkTitle: trans.fetchLabelKeyTranslation('TitleTopics', 'Create Topics'),
      description:trans.fetchLabelKeyTranslation('DescTopics','Create custom topics'),
      permissions: [AccessPermissionEnum.ManageTopics]
    },
    { 
      icon:['bi-person-vcard'],
      link: '/settings/scorecards',
      linkTitle: trans.fetchLabelKeyTranslation('TitleScorecards', 'Create Scorecards') ,
      description: trans.fetchLabelKeyTranslation('DescScorecards', 'Create custom scorecards'),
      permissions: [AccessPermissionEnum.ManageScorecards]
    },
    { 
      icon:['bi-app-indicator'],
      link: '/settings/notification-setup',
      linkTitle: trans.fetchLabelKeyTranslation('TitleNotificationRules', 'Create Notification Rules') ,
      description: trans.fetchLabelKeyTranslation('DescNotificationRules', 'Notification rules allow you to specify the types of calls notifications should be received for') ,
      permissions: [AccessPermissionEnum.EvaluateCalls]
    },
    { 
      icon:['bi-megaphone'],
      link: '/settings/outcomes',
      linkTitle:  trans.fetchLabelKeyTranslation('TitleCallOutcomes', 'Set Call Outcomes') ,
      description: trans.fetchLabelKeyTranslation('DescCallOutcomes','User defined outcomes that can be assigned to a call'),
      permissions: [AccessPermissionEnum.ManageOutcomes]
    },
    { 
      icon:['bi-sd-card'],
      link: '/settings/system?selectedtab=1',
      linkTitle:  trans.fetchLabelKeyTranslation('TitleStorage', 'Storage Setups') ,
      description: trans.fetchLabelKeyTranslation('DescStorageSetups','Setup your storage location') ,
      permissions: [AccessPermissionEnum.ManageAccount]
    },
    { 
      icon:['bi-code-slash'],
      link: '/settings/system?selectedtab=4',
      linkTitle: trans.fetchLabelKeyTranslation('TitleCLIMasking', 'CLI Masking') ,
      description: trans.fetchLabelKeyTranslation('DescCLIMasking','Configure the masking required for CLIs'),
      permissions: [AccessPermissionEnum.ManageAccount]
    },
    { 
      icon:['bi-columns-gap'],
      link: '/settings/system?selectedtab=7',
      linkTitle: trans.fetchLabelKeyTranslation('TitleCRMSetup', 'CRM Setup') ,
      description: trans.fetchLabelKeyTranslation('DescCRMSetup','Sync the product with your CRM'),
      permissions: [AccessPermissionEnum.ManageAccount]
    },
  ];

  const getMyPeople = (userId: number, allUsers: User[]) => {
        let _directReportsToUserId = allUsers.filter(
          (su) => su.manager?.id === userId
        );
        if (_directReportsToUserId && _directReportsToUserId.length > 0) {
          _directReportsToUserId.forEach((ele) => {
            if (_tempMyPeople.findIndex((tp) => tp.id === ele.id) === -1) {
              _tempMyPeople = [..._tempMyPeople, ele];
              getMyPeople(ele.id, allUsers);
            }
          });
        }
      };

    const updateUserRecordingNetwork  = async (userDetails: User, allUsers: User[], devices : DeviceAllocation[] | undefined) => {

        let _userRecordingNetworkGroups: IUserRecordingNetworkGroup[] = [];
        let _masterDataUsers = [
            ...(allUsers.filter((u) => !u.isArchived) ?? []),
        ];
        let userGroups = await userGroupsService.getUserGroups();
        let recordingNetworkAccessiblity = await welcomejourneyService.getRecordingNetworkAccessibility();

        const currentViaPeople =
            recordingNetworkAccessiblity.find(
            (rna) => rna.id === userDetails.recordingNetworkAccessibilty?.id
            );
        let _userOrganization: IUserRecordingNetworkGroup = {
            groupDetail: {
            name: currentViaPeople?.localizationValue ?? "Organization",
            id: currentViaPeople?.id ?? -1,
            },
            users: [],
        };
        if (userDetails.recordingNetworkAccessibilty?.id === 1) {
            const _ownData = _masterDataUsers.filter(
            (su) => su.id === userDetails.id
            );
            if (_ownData) {
            _userOrganization.users = [..._ownData];
            }
        } else if (userDetails.recordingNetworkAccessibilty?.id === 2) {
            let _directReports = sortUsersData(
            _masterDataUsers.filter((su) => su.manager?.id === userDetails.id)
            );
            if (_directReports) {
            _userOrganization.users = [..._directReports];
            }
        } else if (userDetails.recordingNetworkAccessibilty?.id === 3) {
            _tempMyPeople = [];
            getMyPeople(userDetails.id, allUsers);
            _userOrganization.users = sortUsersData([..._tempMyPeople]);
            _tempMyPeople = [];
        } else if (userDetails.recordingNetworkAccessibilty?.id === 4) {
            _userOrganization.users = sortUsersData([..._masterDataUsers]);
        }
        _userRecordingNetworkGroups.push(_userOrganization);

        // Adding associated groups playback network....
        userDetails?.associatedGroups?.playbackNetwork?.forEach((gp) => {
            const _group = userGroups?.find((ug) => ug.id === gp.id);
            if (_group) {
            let _userNetworkGroup: IUserRecordingNetworkGroup = {
                groupDetail: _group,
                users: [],
            };
            _group.groupMembers.forEach((gm) => {
                const _member = allUsers.find(
                (su) => su.id === gm.member.id
                );
                if (_member) {
                _userNetworkGroup.users.push(_member);
                }
            });
            _userRecordingNetworkGroups.push(_userNetworkGroup);
            }
        });

        let _dialogdata: SupervisorWelcomeData[] = [];

        _userRecordingNetworkGroups[0].users.forEach((gp) => {
            var _dialogUser : SupervisorWelcomeData = {
                icon: getIcon(gp.firstName, gp.lastName),
                title: getTitle(gp.firstName, gp.lastName),
                user: gp.email,
                license: transLicense.fetchLabelKeyTranslation(gp.licensePackage?.localizationKey??"", gp.licensePackage?.name??""),
                recordingPolicy: devices? getRecordingPolicy(gp.id, devices) : ""
            };
            _dialogdata.push(_dialogUser);
        });

        setDialogData(_dialogdata);
    };

    const getRecordingPolicy = (id: number, devices : DeviceAllocation[]) => {
      var userDevice = devices?.find((x)=>{ return x.user?.id == id});

      if(userDevice)
      {
          return userDevice.teamsRecordingMode?.modeName??"";
      }
      else{
        return "";
      }
    };

    const getTitle = (firstName?: string, lastName?: string) => {
      return firstName??"" + " " + lastName??"";
    };

    const getIcon = (firstName?: string, lastName?: string) => {
      return (firstName??"").charAt(0) + (lastName??"").charAt(0);
    }

    const ToDashboard = async () => {      
      navigate(`/home?language=${language}`, { replace: true });
    };

    const landingpageSeen = async () => {
      await welcomejourneyService.updateLandingPageSeen();
    };

    const getAllUsers = async (devices : DeviceAllocation[] | undefined) => { 
      if(auth?.user && auth?.user.id)
      {        
          var allUsers = await usersService.fetchUsers();
          var user = await usersService.getUser(auth?.user.id.toString());
          
          updateUserRecordingNetwork(user, allUsers, devices);
      }
    };

    const getCustomerDetails = async () => {
      const custDetails = await customerService.getCustomerDetailsById(
        auth?.tokenPayload?.CustomerId ?? 0
      );

      if(custDetails?.platformDetails.some((platform) => platform.platform === "MsTeams"))
      {
        setIsTeams(true);
      }
      else{
        setIsTeams(false);
      }
      return custDetails;
    };

    const getMsTeamsDevices = async () => {
      const _devices = await deviceService.getAllCustomerDevice("MsTeams");
      return _devices;
    };

    const bindUsersGrid = async () => {
      setDataloading(true);
      var custDetails = await getCustomerDetails();

      let devices : DeviceAllocation[] | undefined = undefined;

      if(custDetails?.platformDetails.some((platform) => platform.platform === "MsTeams"))
      {
        devices = await getMsTeamsDevices();
      }

      await getAllUsers(devices);
      setDataloading(false); 
    };

    useEffect(()=>{      
      if(auth?.userPermissions && auth?.userPermissions.length > 0 && auth?.tokenPayload?.CustomerId)
      {
        landingpageSeen();

        if(auth?.checkUserAccess(AccessPermissionEnum.ManageSecurityControl))
        {
          setIsAdmin(true);
        }else{
          setIsAdmin(false);
          bindUsersGrid();          
        }
      }        
  },[auth?.tokenPayload?.CustomerId, auth?.user]);

  return (<div>{dataloading && (
      <Loader
        type={"infinite-spinner"}
        themeColor={"primary"}
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      />
    )}{!dataloading && (
      <div className='h-w-fixed'>
      <div className="hero-MaxExp bg-primary">
        <div className="cardMaxExp">
          <HeaderExp title={ trans.fetchLabelKeyTranslation('TitleMaxExperience', 'Maximize Your Experience !') } description={ trans.fetchLabelKeyTranslation('ProductFeatures', 'Some features of our product.') }/>
          <div className='exp-body-container h-100'>
            { !isAdmin ?
              <div className='user-list-body px-2 mb-4'>
                <div className="mb-2 d-flex">
                  <h5 className='m-0'><i className="bi bi-person-lines-fill mr-2"></i></h5>
                  <span className='fs-13'>
                    {trans.fetchLabelKeyTranslation("MemberList","Some other members list with license's.")} 
                  </span>
                </div>
                <div className="exp-table-container">
                  <div className="exp-table-body border">
                    <div className="exp-table">
                      <table className="table mb-0 table-hover border-0">
                        <thead className='text-secondary'>
                          <tr>
                            <th className='border-top-0 font-weight-normal fs-13 line-height-1' scope="col"> {trans.fetchLabelKeyTranslation('UserList', 'User List')} </th>
                            <th className='border-top-0 font-weight-normal fs-13 line-height-1' scope="col"> {trans.fetchLabelKeyTranslation('License','License')} </th>
                            {isTeams && (<th className='border-top-0 font-weight-normal fs-13 line-height-1' scope="col"> {trans.fetchLabelKeyTranslation('RecordingPolicy', 'Recording Policy')} </th>)}
                          </tr>
                        </thead>
                        <tbody>
                          {dialogData?.map((item, index) => (
                            <MemberRowTable key={index} icon={item.icon} email={item.user} title={item.title} policy={item.recordingPolicy} license={item.license} isTeams={isTeams??false}/>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            :
              <span className='exp-description-2 text-center pb-2 px-2'>
                <u> {trans.fetchLabelKeyTranslation('PlatformSteps','To get the most out of the platform, you can complete the following setup steps')}: </u>
              </span>
              
            }
            <div className='list-item-body'>
              {
              dataList.filter((x) => {
                return x.permissions.find((y) => { return auth?.checkUserAccess(y) }) ;
              }).map((item, index) => (
                  <ExpList key={index} icon={item.icon} link={item.link} linkTitle={item.linkTitle} description={item.description} permissions={item.permissions}/>
                ))
              }
            </div>
          </div>
            <Button
              onClick={ToDashboard}
              className='btn-primary  d-flex ml-auto max-exp-btn '
            >
            { trans.fetchLabelKeyTranslation('ToDashboard','To Product') } <h5 className='m-0'><i className="bi bi-arrow-right ml-2"></i></h5>
            </Button>
        </div>
      </div>
      </div>)}
    </div>
  );
};


export default MaxExperience;
